import clsx from "clsx";
import React from "react";
import { ProductModalHeader } from "../../pages/Pass/components/SelectOptionSection/ProductModalHeader";

export const ProductPopup = ({
  product,
  closeModal,
  children,
}: {
  product?: ProductDetailResponse;
  closeModal?: () => void;
  children?: React.ReactNode;
}) => {
  const childrenLs = React.Children.toArray(children);
  const maxHeight = 700;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div
        className={clsx(
          "relative w-full max-w-[28.125rem] rounded-[1rem] border border-[#D7DCE3] bg-white shadow-lg",
          // "h-full",
        )}
        style={{
          maxHeight,
        }}
      >
        <ProductModalHeader product={product} closeModal={closeModal} />
        <div className="flex flex-col px-6 pb-4">
          <div
            className="product-popup-content custom-scroll-bar !mr-[-1rem] overflow-y-auto pb-2 pr-2 pt-4"
            style={{ maxHeight: maxHeight - 302 }}
          >
            {childrenLs[0]}
          </div>
          {childrenLs[1]}
        </div>
      </div>
    </div>
  );
};
